import type { IOidcSettings } from '../../types';

//This method returns the oidc settings for oidc authentication
const getAuthSettings = async (): Promise<IOidcSettings> => {
  return fetch('/oidc.config.json').then((response) => response.json());
};

export const authSettings = await getAuthSettings();
